import { PursuitsPageState } from './State'
import { SET_PURSUIT, SET_PURSUITS, SET_EDIT, DELETE_PURSUIT, PursuitsPageAction } from './Actions'

function pursuitsPageReducer(state: PursuitsPageState, action: PursuitsPageAction): PursuitsPageState {
  switch (action.type) {
    case SET_PURSUIT:
      state.passions[action.payload.index][action.payload.questionKey] = action.payload.response
      return Object.assign({}, state)
    case SET_PURSUITS:
      return Object.assign({}, state, {
        passions: action.payload
      })
    case DELETE_PURSUIT:
      state.passions[action.payload] = { title: '', detail: '' }
      return state
    case SET_EDIT:
      return Object.assign({}, state, { edit: action.payload })
    default:
      return state
  }
}

export default pursuitsPageReducer
